import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesOrderCancelledActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Bakery/Partner/PartnerBrowser")
	}

	render() {
		return (
			<Activity 
				name="Customer"
				RenderedComponent={this.RenderedComponent}
				context="isCustomer"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesOrderCancelledActivity)
